import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 6a6 6 0 0 1 6-6h36a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#99C3FF",
  d: "M35.429 20.962a7.3 7.3 0 0 1 .929 3.625c-.034 4.219-3.696 7.597-8.132 7.597h-7.971v2.274c0 1.076-1.317 1.545-2.063.837l-4.026-3.828a1.12 1.12 0 0 1-.354-.812c0-.305.128-.597.354-.813l4.026-3.828c.76-.723 2.063-.208 2.063.814v2.297h7.995c2.657 0 4.86-2.019 4.887-4.547a4.4 4.4 0 0 0-.464-2.012 1.1 1.1 0 0 1-.098-.69c.043-.234.162-.449.34-.616l.597-.564c.133-.127.295-.222.474-.278a1.27 1.27 0 0 1 1.072.149c.154.102.281.238.37.395"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0068FF",
  d: "m14.35 28.185-.598.564a1.2 1.2 0 0 1-.474.278 1.27 1.27 0 0 1-1.072-.15 1.2 1.2 0 0 1-.37-.395 7.3 7.3 0 0 1-.93-3.624c.034-4.218 3.696-7.6 8.132-7.6h7.971v-2.27c0-1.066 1.308-1.553 2.063-.838l4.026 3.829c.227.215.354.507.354.812 0 .304-.127.596-.354.811l-4.026 3.829c-.747.71-2.063.235-2.063-.836V20.32h-7.995c-2.657 0-4.86 2.019-4.887 4.546-.008.695.15 1.382.464 2.01.108.215.143.456.1.691-.044.235-.163.45-.341.618"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }